import { createContext, useContext } from 'react';
import useScroll from '../../hooks/useScroll';
import type { CarouselProps } from './types';

export const DEFAULT_BREAKPOINTS = { default: 1 };

export type CarouselContextProps = Pick<CarouselProps, 'breakpoints'> &
    Partial<ReturnType<typeof useScroll>> & {
        hovered?: boolean;
    };

const CarouselContext = createContext<CarouselContextProps>({
    breakpoints: DEFAULT_BREAKPOINTS,
});

export const CarouselContextProvider = CarouselContext.Provider;
export const useCarouselContext = () => useContext(CarouselContext);
